module.exports = __webpack_public_path__ + "assets/52f9e0e96c169221853f42fa04838b8e.png";